var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('BaseTopBar',{attrs:{"breadcrump":false,"icon":_vm.icon,"title":_vm.title}}),_c('dashboard-info'),_c('BaseGrid',[_c('div',[_c('dashboard-user-info-list'),_c('dashboard-calendar-list')],1),_c('dashboard-project-list'),_c('dashboard-activity-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }